import {machineData} from './machine_interface';


export const COUNTRIES: machineData[] = [
  {
    "id": 11,
    "MachineId": 1,
    "Machine_OrgId": "1_225",
    "OrgId": 225,
    "MachineType": "BOT_CREATOR",
    "MachineName": "MSEDGEWIN10",
    "MachineUserId": 2,
    "MachineUserName": "stvasu",
    "MachineStatus": "DISCONNECTED",
    "poolName": "",
    "fullyQualifiedHostName": "MSEDGEWIN10"
},
{
    "id": 12,
    "MachineId": 3,
    "Machine_OrgId": "3_225",
    "OrgId": 225,
    "MachineType": "BOT_RUNNER",
    "MachineName": "TESTINGPCVM.btc.com",
    "MachineUserId": 5,
    "MachineUserName": "btcbotrun",
    "MachineStatus": "DISCONNECTED",
    "poolName": "",
    "fullyQualifiedHostName": "TESTINGPCVM.btc.com"
}
  
];
